/**
 * Normalize agent-authored text for rendering: models sometimes
 * double-escape inside JSON tool payloads, leaving literal backslash-n,
 * backslash-t and backslash-quote sequences in the stored strings.
 *
 * Inline <cite>chunk_id</cite> markers are dropped: these views have no
 * dialogue citation context to resolve them against, and every block that
 * carries them renders its own human-readable Citations line.
 */
export const normalizeMultiline = (text: string | null | undefined): string => {
  if (!text) return "";
  return text
    .replace(/\\r\\n/g, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\\t/g, "  ")
    .replace(/\\"/g, '"')
    .replace(/<cite>(?:\d+|\{.*?\})<\/cite>/g, "")
    .replace(/[ \t]+([.,;:)])/g, "$1");
};
